import { useState } from 'react';
import { useNavigate } from 'react-router';
import { Page, Spacer } from '../../components';
import MembersOffboardingHeader from './MembersOffboardingHeader';
import MembersDashboardHeader from './MembersDashboardHeader';
import { MembersDataTable } from './MembersDataTable';

interface MembersProps {
  variant?: 'restrictMembers' | 'dashboard';
}

const Members: React.FC<MembersProps> = ({ variant = 'dashboard' }) => {
  const navigate = useNavigate();
  const [addMemberDrawer, setAddMemberDrawer] = useState(false);
  const [searchWord, setSearchWord] = useState('');
  const [filteredMembersData, setFilteredMembersData] = useState<any[]>([]);

  const onBulkAdd = () => navigate('add');
  const onBulkRemove = () => navigate('remove');
  const restrictMembersView = variant === 'restrictMembers';

  const handleDataChange = (filteredData: any[]) => {
    setFilteredMembersData(filteredData);
  };

  return (
    <Page
      title={restrictMembersView ? undefined : 'Members'}
      style={restrictMembersView ? { margin: 0 } : undefined}>
      <Spacer height='xxs' />
      {restrictMembersView ? (
        <MembersOffboardingHeader onBulkAdd={onBulkAdd} setAddMemberDrawer={setAddMemberDrawer} />
      ) : (
        <MembersDashboardHeader
          filteredMembersDataForTable={filteredMembersData}
          setSearchWord={setSearchWord}
          onBulkAdd={onBulkAdd}
          onBulkRemove={onBulkRemove}
          setAddMemberDrawer={setAddMemberDrawer}
        />
      )}
      <Spacer height='xxs' />
      <MembersDataTable
        searchWord={searchWord}
        addMemberDrawerOpen={addMemberDrawer}
        setAddMemberDrawerOpen={setAddMemberDrawer}
        onDataChange={handleDataChange}
      />
    </Page>
  );
};

export default Members;
